/* eslint-disable import/prefer-default-export */
export const COURSE_DATA = `
query($moduleId: Int, $type: String, $courseId: Int, $unitId: Int, $mode: String, $examType: String, $examMode: String, $projectCode: String, $levelCode: String, $action: String, $testId: Int, $overviewId: Int, $count: Int){
  chineseCourseData(moduleId: $moduleId, type: $type, courseId: $courseId, unitId: $unitId, mode: $mode, examType: $examType, examMode: $examMode, projectCode: $projectCode, levelCode: $levelCode, action: $action, testId: $testId, overviewId: $overviewId, count: $count){
    id
    type
    status
    navigation
    title
    subtitle
    description
    isBacktrack
    message
    playTimes
    quizzes{
      id
      code
      mode
      parentId
      ... on ChineseCourseQuizQHLJ {
        image
        text
        explain
        fix {
          word
          tag
        }
        parse {
          audio
          text
        }
        userAnswer
      }
      ... on ChineseCourseQuizDX {
        answer
        answerIndex
        question
        options
        parse {
          audio
          text
        }
        userAnswer
      }
      ... on ChineseCourseQuizBQWZ {
        article
        extras
        parts {
          id
          answer
          parse {
            audio
            text
          }
        }
        parse {
          audio
          text
        }
        userAnswer
      }
      ... on ChineseCourseQuizMED {
        duration
        items {
          id
          duration
          text
          explain
          audio
          image
        }
      }
      ... on ChineseCourseQuizKY {
        text
        audio
        beep
        image
        explain
      }
      ... on ChineseCourseQuizJXZH {
        question
        answer
        extras
        parse {
          audio
          text
        }
        userAnswer
      }
      ... on ChineseCourseQuizTYLJ {
        text
        explain
        answer
        audio
        extras
        userAnswer
      }
      ... on ChineseCourseQuizWK {
        video
        poster
        videoDone
        quizzes {
          question
          options
          answer
          type
          time
        }
      }
      ... on ChineseCourseQuizCHXZ {
        text
        explain
        audio
        options
        answer
        gameId
        userAnswer
      }
      ... on ChineseCourseQuizDCTX {
        text
        explain
        audio
        gameId
        userAnswer
      }
      ... on ChineseCourseQuizSK {
        text
        explain
        phonetic
        audio
        exampleSentence
        exampleExplain
        gameId
      }
      ... on ChineseCourseQuizHYDC {
        text
        explain
        audio
        gameId
        userAnswer
      }
      ... on ChineseCourseQuizDCPX {
        text
        explain
        fixs
        audio
        gameId
        userAnswer
      }
      ... on ChineseCourseQuizYDLJ {
        article
        userAnswer
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizWXTK {
        article
        userAnswer
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizTHXZ {
        article
        userAnswer
        audio
        playTimes
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizXCTK {
        article
        userAnswer
        extras
        parse {
          audio
          text
        }
        items {
          id
          answer
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizBS {
        article
        title
        author
        hint
      }
      ... on ChineseCourseQuizTK {
        title
        text
        image
        explain
        userAnswer
      }
    }
  }
}`;

export const COURSE_RESULT = `
mutation ($id: Int, $courseId: Int, $unitId: Int, $moduleId: Int, $type: String, $mode: String, $quizzes: String!, $spend: String, $seconds: Int, $isBacktrack: Int, $levelCode: String) {
  chineseCourseResult(id: $id, courseId: $courseId, unitId: $unitId, moduleId: $moduleId, type: $type, mode: $mode, quizzes: $quizzes, spend: $spend, seconds: $seconds, isBacktrack: $isBacktrack, levelCode: $levelCode) {
    examId
    score
    progress
    isContinue
    bookReview
    message
    name
    schoolName
    bookName
    unitName
    wordCount
    time
    star
    exp
    nextLevelInfo {
      itemType
      itemCode
      unitId
    }
  }
}`;
